// @ts-nocheck
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
 
 
 
 
/* eslint-disable no-nested-ternary */
import { FluxStandardAction } from 'redux-promise-middleware';

import { alertConstants } from '_constants';
import { Alert } from 'types';
import { useIntl } from 'react-intl';
const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us' //	ar-eg
const alert = (state = null, action: FluxStandardAction): Alert | null => {
  
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'success',
        message: action.payload,
      };

    case alertConstants.ERROR:
      
      return {
        type: 'error',
        message: 
        ( action.payload &&  (action.payload).includes("Device limit exceeded for") == true)
        ?  currentLanguageCode =='en-us' ? "Sorry, you have reached your limit" :"عذرا , لقد وصلت إلى الحد الاقصي" 
        : action.payload,
      };

    case alertConstants.CLEAR:
      return null;

    default:
      return state;
  }
};

export { alert };
